'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeWalletIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeWalletIcon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.3688 1.2793C4.86305 1.2793 0.399902 5.74244 0.399902 11.2482V34.447C0.399902 36.8064 2.31276 38.7193 4.67219 38.7193H32.3342C34.6936 38.7193 36.6065 36.8064 36.6065 34.447V14.5093C36.6065 12.1499 34.6936 10.237 32.3342 10.237H31.7245C31.6696 10.2424 31.6145 10.2453 31.5593 10.2456H9.95562C8.58533 10.2402 7.73476 8.7533 8.42476 7.5693C8.74247 7.02415 9.32476 6.68787 9.95562 6.6853H30.3062V2.70358C30.3062 1.91701 29.6685 1.2793 28.8822 1.2793H10.3688Z"
          fill="#D8DCE5"
        />
        <path
          d="M38.1761 20.6797H28.2072C27.4212 20.6797 26.7832 21.2491 26.7832 21.9471V27.0111C26.7832 27.7117 27.4212 28.2785 28.2072 28.2785H38.1761C38.9621 28.2785 39.6001 27.7088 39.6001 27.0111V21.9471C39.6001 21.2463 38.9621 20.6797 38.1761 20.6797Z"
          fill="#3D517B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.3064 10.2458V6.68556H9.95585C8.58557 6.68013 7.72328 8.16013 8.40357 9.34956C8.72185 9.90613 9.31471 10.2484 9.95585 10.2458H30.3064Z"
          fill="#3D517B"
        />
      </svg>
    </SvgIcon>
  )
}

LargeWalletIcon.propTypes = {
  sx: PropTypes.object
}
